"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getRoundedStyle = void 0;
function getRoundedStyle() {
    return {
        h: 9,
        w: 9,
        borderRadius: 25,
        justifyContent: 'center',
    };
}
exports.getRoundedStyle = getRoundedStyle;
